import React from 'react';
import { Modal } from 'rsuite';

/**
 * This wrapper exists bc rsuite does not export this component as default, and
 * therefore we cannot import it lazily
 */
export default function RsModalHeader(props) {
  return <Modal.Header {...props} />;
}
